module.exports = __webpack_public_path__ + "img/image 5.69374df7.png";